import { Directive, ElementRef, inject, input, OnInit } from '@angular/core';
import { InputFillMode } from '@progress/kendo-angular-inputs';

@Directive({
  selector: '[unityFormFillMode]',
  standalone: true,
})
export class FormFillModeDirective implements OnInit {
  public readonly $unityFormFillMode = input<InputFillMode>('flat', { alias: 'unityFormFillMode' }); // Default value

  private readonly el = inject(ElementRef);

  public ngOnInit(): void {
    const kendoControl = this.el.nativeElement;
    if (kendoControl && kendoControl.kendo) {
      kendoControl.fillMode = this.$unityFormFillMode();
    }
  }
}
